import { useLocation } from 'react-router-dom';
import { NavCapability, SettingsNavItem, SettingsNavSection, storefrontNav } from 'src/config/storefrontNav';
import { useAuthPermissions } from 'src/hooks/useAuthPermissions';

export const FALLBACK_PATH = '/dashboard/selling';

type CapabilityMap = Record<NavCapability, boolean>;

/** Pure, so filtering is testable without a session — the same shape as useSettingsNav. */
export function selectStorefrontSections(
  permissions: CapabilityMap,
  sections: SettingsNavSection[]
): SettingsNavSection[] {
  return sections.filter((section) => permissions[section.capability]);
}

export function resolveFirstAllowedPath(sections: SettingsNavSection[]): string {
  return sections[0]?.items[0]?.path || FALLBACK_PATH;
}

export function useStorefrontNav(): {
  ready: boolean;
  sections: SettingsNavSection[];
  activeItem?: SettingsNavItem;
  firstAllowedPath: string;
} {
  const { ready, canManageOrg, canManageRestaurant, canManageRestaurantSettings } = useAuthPermissions();
  const { pathname } = useLocation();

  const sections = selectStorefrontSections(
    { canManageOrg, canManageRestaurant, canManageRestaurantSettings },
    storefrontNav
  );
  const activeItem = sections.flatMap((section) => section.items).find((item) => item.path === pathname);

  return { ready, sections, activeItem, firstAllowedPath: resolveFirstAllowedPath(sections) };
}
